// extracted by mini-css-extract-plugin
module.exports = {"addToWatchlist":"H86KTM","iconContainer":"SrQ_5p","inWatchlist":"btEH5B"};